import React from "react";
import { Box } from "@mui/material";
import Popup from "../../../component/popup/Popup.js";
import AddNewMemberContent from "./AddNewMemberContent.js";

const AddNewMemberPopup = ({
    open,
    onClose,
    options,
    onCreate,
    onSetError,
}) => {
    return (
        <Popup
            open={open}
            onClose={onClose}
            popupStyle={{
                minWidth: 1000,
                maxWidth: 1000,
            }}
            modalStyle={{
                "& .MuiBox-root.css-ft9d2q": {
                    borderRadius: "10px 10px 0 0",
                },
            }}
            title="Add New Member"
        >
            <Box sx={{ px: 4, pt: 2, pb: 1 }}>
                <AddNewMemberContent
                    options={options}
                    onCreate={onCreate}
                    onSetError={onSetError}
                    showCreate
                />
            </Box>
        </Popup>
    );
};

export default AddNewMemberPopup;
